import { render } from "./EditDevoir.vue?vue&type=template&id=0e57073b&scoped=true&ts=true"
import script from "./EditDevoir.vue?vue&type=script&lang=ts"
export * from "./EditDevoir.vue?vue&type=script&lang=ts"

import "./EditDevoir.vue?vue&type=style&index=0&id=0e57073b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e57073b"]])

export default __exports__